export default {
  promoCard: {
    container: 'dt.loyalty.whalersClub.promoCard.container',
    moreButton: 'dt.loyalty.whalersClub.promoCard.moreButton',
    dismissButton: 'dt.loyalty.whalersClub.promoCard.dismissButton',
  },
  detailModal: {
    container: 'dt.loyalty.whalersClub.detailModal.container',
    tierBadge: 'dt.loyalty.whalersClub.detailModal.tierBadge',
    statusRow: 'dt.loyalty.whalersClub.detailModal.statusRow',
    rewardPill: 'dt.loyalty.whalersClub.detailModal.rewardPill',
    progressBar: 'dt.loyalty.whalersClub.detailModal.progressBar',
    faqAccordion: 'dt.loyalty.whalersClub.detailModal.faqAccordion',
    rewardsHistoryLink: 'dt.loyalty.whalersClub.detailModal.rewardsHistoryLink',
  },
};
